/* eslint-disable max-len */
import _ from 'lodash';

import { APP_CONFIG } from 'common/constants';

export const fileLinkIMGIX = (data, params) => {
	if (!data) {
		return null;
	}

	return data.selected === 'file' ? formatLink(_.get(data, 'file.url', ''), params) : _.get(data, 'remoteURL', '');
};

export const formatLink = (path, faceIndex = '0', params) => {
	const defaultParams = `?auto=compress&auto=format&w=250&h=350&&fit=facearea&facepad=10&faces=1&faceindex=${faceIndex}`;
	let link;
	if (path !== '') {
		link = `https://ynet-memorialday2026.imgix.net/${path}${params ?? defaultParams}`;
		// link = `https://storage.googleapis.com/ynet-memorial-day-candles-2025.firebasestorage.app/${path}`;
	} else {
		link = `${APP_CONFIG.domains.client.hostname}/assets/client/share1200x600.jpeg`;
	}

	return link;
};
